import { NavLink } from 'react-router-dom'
import ListItem from '@mui/material/ListItem'
import cn from 'classnames'
import Text from '../../Common/Text'
import styles from '../SideMenuClient.module.scss'
import { ISubMenuData } from '../SideMenuConfig'

interface IProps extends ISubMenuData {
  sidebarExpanded: boolean
  toggleSidebar?: () => void
}

const NestedNavItem = ({ link, label, icon, sidebarExpanded, toggleSidebar }: IProps) => {
  return (
    <NavLink
      key={link}
      to={link}
      className={({ isActive }) => (isActive ? styles.active : '')}
      onClick={() => {
        if (toggleSidebar) {
          toggleSidebar()
        }
      }}
    >
      <ListItem className={styles.nestedItem}>
        <div className={cn(styles.icon, styles.nestedIcon)}>{icon}</div>
        {sidebarExpanded && (
          <span className={styles.expandableLabel}>
            <Text variant="bodySm" casing="none" component="span">
              {label}
            </Text>
          </span>
        )}
      </ListItem>
    </NavLink>
  )
}

export default NestedNavItem
